import React from 'react';
import {useNavigate} from 'react-router-dom';
import {toggleFavorite} from '../../api/coordiApi';
import {CoordinatorData} from '../../interface/CoordinatorData';
import {defaultConfirm} from "../../utils/alert";
import {maskName} from "../../utils/format";
import manImage from '../../assets/images/man_default_img.png';
import womanImage from '../../assets/images/woman_default_img.png';

interface CoordinatorCardProps {
    coordinator: CoordinatorData;
    onFavoriteToggle: (coordinatorCode: string) => void;
}

const CoordinatorCard = ({coordinator, onFavoriteToggle}: CoordinatorCardProps) => {
    const navigate = useNavigate();
    const [isFavorite, setIsFavorite] = React.useState(true); // FavoritePage에서는 모두 true

    const handleFavoriteToggle = async (e: React.ChangeEvent<HTMLInputElement>) => {

        defaultConfirm("즐겨찾기 목록에서 제외하시겠습니까?", "제외", "취소", async (isConfirmed) => {
                if (isConfirmed) {
                    try {
                        await toggleFavorite(coordinator.coordinatorCode);
                        onFavoriteToggle(coordinator.coordinatorCode); // 목록에서 제거
                    } catch (error) {
                        console.error('찜하기 실패:', error);
                        e.target.checked = true; // 실패 시 체크 유지
                    }
                }
            }
        )
    };


    const getGenderIcon = () => {
        return coordinator.gender === '남성' ? 'fa-mars' : 'fa-venus';
    };

    const getProfileImage = () => {
        if (coordinator.imagePath && coordinator.imagePath !== 'default') {
            return coordinator.imagePath;
        }
        return coordinator.gender === '남성' ? manImage : womanImage;
    };

    const getCareerText = (hasCareer: boolean, year: number, month: number) => {
        if (!hasCareer) return '미경력';

        const parts = [];
        if (year > 0) parts.push(`${year}년`);
        if (month > 0) parts.push(`${month}개월`);

        return parts.length > 0 ? parts.join(' ') : '미경력';
    };

    return (
        <div className="round-box">
            <div className="round-body">
                <div className="coordi-profile-box">
                    <div className="coordi-info">
                        <p className="name">
                            {maskName(coordinator.memberName)}
                            <span className="career">
                                {getCareerText(coordinator.hasCareer, coordinator.careerYear, coordinator.careerMonth)}
                            </span>
                        </p>
                    </div>
                    <span className="like-check">
                        <input
                            type="checkbox"
                            id={`favorites-${coordinator.coordinatorCode}`}
                            className="blind"
                            checked={isFavorite}
                            onChange={handleFavoriteToggle}
                        />
                        <label htmlFor={`favorites-${coordinator.coordinatorCode}`}></label>
                    </span>
                    <div className="profile-img">
                        <div className="thumbnail-wrap">
                            <div className="thumbnail">
                                <div className="centered">
                                    <img
                                        src={getProfileImage()}
                                        alt={coordinator.memberName}
                                        className="portrait"
                                        onError={(e) => {
                                            (e.target as HTMLImageElement).src = coordinator.gender === '남성' ? manImage : womanImage;
                                        }}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="coordi-cate">
                    <div className="ico-info">
                        <p className="tit">나이</p>
                        <p className="cont">
                            <i className="fa-regular fa-file-lines"></i>
                            {coordinator.age}세
                        </p>
                    </div>
                    <div className="ico-info line">
                        <p className="tit">성별</p>
                        <p className="cont">
                            <i className={`fa-solid ${getGenderIcon()}`}></i>
                            {coordinator.gender}
                        </p>
                    </div>
                    <div className="ico-info line">
                        <p className="tit">국적</p>
                        <p className="cont">{coordinator.nationalityName}</p>
                    </div>
                </div>

                <ul className="career-tit">
                    <li>
                        <span className="tit-cont complete">
                            <i className="fa-solid fa-circle-check"></i>
                            완료 <strong>{coordinator.completed || 0}건</strong>
                        </span>
                    </li>
                    <li>
                        <span className="tit-cont award">
                            <i className="fa-solid fa-award"></i>
                            자격증 <strong>{coordinator.certificates?.length || 0}개</strong>
                        </span>
                    </li>
                    <li>
                        <span className="tit-cont service">
                            <i className="fa-solid fa-thumbs-up"></i>
                            서비스 후기 <strong>{coordinator.reviewCount || 0}건</strong>
                        </span>
                    </li>
                </ul>

                <div className="info-row foot">
                    <button
                        type="button"
                        className="foot-line-btn w100 text-center"
                        onClick={() => navigate(`/coordinator/${coordinator.coordinatorCode}`)}
                    >
                        <i className="fa-solid fa-magnifying-glass"></i>
                        자세히 보기
                    </button>
                </div>
            </div>
        </div>
    );
};

export default CoordinatorCard;